import React from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";

const AddExtraCharge = ({ show, handleClose, handleSave, initialData }) => {
  const formik = useFormik({
    initialValues: {
      chargeId:initialData?.id || "",
      title: initialData?.title || "",
      chargeType: initialData?.chargeType || "",
      amount: initialData?.amount || "",
      taxPercent: initialData?.taxPercent || "",
      userType: initialData?.userType || "",
      status: initialData?.status || "active",
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      title: Yup.string().required("Title is required"),
      chargeType: Yup.string().required("Charge Type required"),
      amount: Yup.string()
        .required("Amount is required"),
     
      taxPercent: Yup.string().required("Tax Type required"),
      userType: Yup.string().required("User Type required"),
      status: Yup.string().required("Status is required"),
    }),
    onSubmit: (values,{resetForm}) => {
      handleSave(values);
      resetForm()
    },
  });

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>Extra Charges</Modal.Title>
        <span onClick={handleClose} style={{ cursor: "pointer" }}>
          X
        </span>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={formik.handleSubmit}>
          <Form.Group controlId="formTitle" className="formIds">
            <Form.Label>Title</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter title"
              {...formik.getFieldProps("title")}
              isInvalid={formik.touched.title && formik.errors.title}
            />
            <span className="formerrro">{formik.errors.title}</span>
          </Form.Group>

          <Form.Group controlId="formChargeType" className="formIds">
            <Form.Label>Charge Type</Form.Label>
            <Form.Control
              as="select"
              {...formik.getFieldProps("chargeType")}
              isInvalid={formik.touched.chargeType && formik.errors.chargeType}
            >
              <option value="">Select Charge Type</option>
              <option value="flat">Flat</option>
              <option value="percent">Percent</option>
            </Form.Control>
            <span className="formerrro">{formik.errors.chargeType}</span>
          </Form.Group>

          <Form.Group controlId="formAmount" className="formIds">
            <Form.Label>Amount</Form.Label>
            <Form.Control
              type="string"
              placeholder="Enter amount"
              {...formik.getFieldProps("amount")}
              isInvalid={formik.touched.amount && formik.errors.amount}
            />
            <span className="formerrro">{formik.errors.amount}</span>
          </Form.Group>

          <Form.Group controlId="formTaxPercent" className="formIds">
            <Form.Label>Tax Percent</Form.Label>
            <Form.Control
              type="string"
              placeholder="Enter tax percent"
              {...formik.getFieldProps("taxPercent")}
              isInvalid={formik.touched.taxPercent && formik.errors.taxPercent}
            />
            <span className="formerrro">{formik.errors.taxPercent}</span>
          </Form.Group>

          <Form.Group controlId="formUserType" className="formIds">
            <Form.Label>User Type</Form.Label>

            <Form.Control
              as="select"
              {...formik.getFieldProps("userType")}
              isInvalid={formik.touched.userType && formik.errors.userType}
            >
              <option value="">Select User Type</option>
              <option value="vendor">Vendor</option>
              <option value="guest">Guest</option>
            </Form.Control>
            <span className="formerrro">{formik.errors.taxPercent}</span>
          </Form.Group>

          <Form.Group controlId="formStatus" className="formIds">
            <Form.Label>Status</Form.Label>
            <Form.Control
              as="select"
              {...formik.getFieldProps("status")}
              isInvalid={formik.touched.status && formik.errors.status}
            >
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </Form.Control>
            <span className="formerrro">{formik.errors.status}</span>
          </Form.Group>

          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
            <Button variant="primary" type="submit">
              Save Changes
            </Button>
          </Modal.Footer>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default AddExtraCharge;
